import { useMemo, useState } from "react";

import { useAccountContext } from "V2.0/Context/AccountContext";
import useCustomers from "V2.0/hooks/useCustomers";

import WorkspaceAccessUsers from "./WorkspaceAccessUsers";
import Workspaces from "./Workspaces";

import { Heading } from "V2.0/common/heading";

function WorkspaceManagement() {
  const [open, setOpen] = useState({
    isOpen: false,
    workspace: null,
  });

  const { workspaces, syncWorkspace, company, isAccountLoading } =
    useAccountContext();

  const { customers, isCustomersLoading } = useCustomers(company?._id);

  return (
    <>
      <div className="w-4/5 mx-auto flex flex-col gap-y-8">
        <div className="flex justify-between">
          <div>
            <Heading>Workspaces</Heading>
          </div>
        </div>
        <Workspaces
          loading={isAccountLoading || isCustomersLoading}
          workspaces={workspaces}
          onWorkspaceClick={(workspace) => setOpen({ isOpen: true, workspace })}
          users={customers}
        />
      </div>
      {open.isOpen && (
        <WorkspaceAccessUsers
          open={open.isOpen}
          onClose={() => setOpen({ isOpen: false, workspace: null })}
          workspace={open.workspace}
          users={customers}
          syncWorkspace={syncWorkspace}
          setOpen={setOpen}
          company={company}
        />
      )}
    </>
  );
}

export default WorkspaceManagement;
